<template>
  <header class="page-banner" :style="{backgroundImage: `url('${imageUrl}')`}">
        <breadcrumb :links="links" class='hidden-mobile'  />
        <div class="page-banner-content site-container">
            <img v-if="icon" :src="require(`@/assets/img/svg/${icon}.svg`)" :title="title" width="50">
            <h1>{{ title }}</h1>
        </div>
  </header>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {

    components: {
        Breadcrumb
    },

    props: ['image', 'title', 'icon', 'links'],

    computed: {

        imageUrl() {
            if (this.image) {
                return require(`@/assets/img/${this.image}`);
            }

            return null;
        }
    }
}
</script>

<style>

</style>
